import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { Icon } from '@/components/atoms/Icon';
import type { LearningObjective } from '@/types/story.types';
import styles from './ObjectiveAchievements.module.scss';

export interface ObjectiveAchievement {
  objective: LearningObjective;
  correct: number;
  total: number;
  pct: number;
  achieved: boolean;
}

interface ObjectiveAchievementsProps {
  achievements: ObjectiveAchievement[];
}

export function ObjectiveAchievements({ achievements }: ObjectiveAchievementsProps) {
  const { t } = useTranslation();

  if (achievements.length === 0) return null;

  return (
    <div className={styles.objectives}>
      <p className={styles.objectives__label}>{t('story.objectivesTitle')}</p>
      <ul className={styles.objectives__list} aria-label={t('story.objectivesTitle')}>
        {achievements.map(({ objective, pct, achieved }) => (
          <li key={objective.id} className={styles.objectives__item}>
            <span
              className={`${styles.objectives__icon} ${achieved ? styles['objectives__icon--achieved'] : styles['objectives__icon--missed']}`}
              aria-hidden="true"
            >
              <Icon icon={achieved ? Check : X} size="xs" />
            </span>
            <span className={styles.objectives__text}>{objective.canStatement}</span>
            <span
              className={`${styles.objectives__pct} ${achieved ? styles['objectives__pct--achieved'] : styles['objectives__pct--missed']}`}
              aria-label={`${pct}%`}
            >
              {pct}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
